import {
  Typography,
  TagsInput,
  TagsInputList,
  TagsInputInput,
  TagsInputItem,
} from "@altimateai/lego";

interface TagsSectionProps {
  tags: string[];
  onChange: (tags: string[]) => void;
}

export const TagsSection: React.FC<TagsSectionProps> = ({ tags, onChange }) => {
  return (
    <div>
      <Typography variant="body" size="sm" weight="medium" className="al-mb-2 al-block">
        Tags
      </Typography>
      <TagsInput value={tags} onValueChange={(newTags: string[]) => onChange(newTags)}>
        <TagsInputList>
          {tags.map(tag => (
            <TagsInputItem
              key={tag}
              value={tag}
              className="!al-bg-cyan-100 !al-text-cyan-700 al-border al-border-cyan-200 al-rounded-md"
            >
              {tag}
            </TagsInputItem>
          ))}
          <TagsInputInput placeholder="Type a tag and press Enter..." />
        </TagsInputList>
      </TagsInput>
    </div>
  );
};
